import { API, Auth } from "aws-amplify";
import { Alert, Button, Form, Input, Layout, Spin } from "antd";
//import { setUnlocked } from "../features/user/userSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { GRAPHQL_AUTH_MODE, GraphQLResult } from "@aws-amplify/api-graphql";
//import { SetScreenLockMutation } from "../API";
//import { setScreenLock } from "../graphql/mutations";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { AppDispatch } from "../../app/store";
import React from "react";
import {
  ThemeMode,
  selectTheme,
  setMode,
  setShowPinForm,
} from "../../features/theme/themeSlice";
import { useAppSelector } from "../../app/hooks";

const LockedLayout: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useAppSelector(selectTheme);
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {}, [theme]);

  const onFinish = (values: any) => {
    console.log("onFinish");

    if (values.pin === "1234") {
      dispatch(setMode(ThemeMode.KIOSKADMIN));
      localStorage.setItem("kiosk", "false");
      dispatch(setShowPinForm(false));
      navigate("/");
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Layout className="center">
      <Layout.Content className="layout">
        <Spin spinning={loading} size="large">
          {error && (
            <Alert
              message={intl.formatMessage({ id: "pin.error" })}
              type="error"
              style={{ padding: "6px 8px" }}
            />
          )}
          <br />
          <Form
            name="normal_login"
            className="login-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item name="pin">
              <Input.Password
                name="password"
                placeholder="input PIN"
                style={{ borderRadius: "6px" }}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Admin Mode
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </Layout.Content>
    </Layout>
  );
};

export default LockedLayout;
